import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from '../../../services/headers'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const sendMessage = (roomKey, payload) =>
  getClient()
    .then(client => client.post(`rooms/${roomKey}/messages`, payload))
    .then(response => response.data)

export const closeConversation = (roomKey, user) =>
  getClient()
    .then(client => client.put(`rooms/${roomKey}/close`, user))
    .then(response => response.data)

export const createChat = (payload = {}) =>
  getClient()
    .then(client =>
      client.post('rooms', {
        ...payload,
        clientTimeZone: new Date().getTimezoneOffset()
      })
    )
    .then(response => response.data)

export const updateChatCustomFields = (roomKey, customFields = []) => {
  if (!roomKey) {
    return Promise.resolve(null)
  }

  return getClient()
    .then(client => client.put(`rooms/${roomKey}/custom-fields`, customFields))
    .then(response => response.data)
}

export const updateChatOrganization = (roomKey, organization) => {
  if (!roomKey) {
    throw new Error('updateChatOrganization roomKey is required')
  }

  return getClient()
    .then(client => client.put(`rooms/${roomKey}/organization`, organization))
    .then(res => res.data)
}

export const startFluxBot = roomKey =>
  getClient()
    .then(client => client.post(`rooms/${roomKey}/bot/start`))
    .then(res => res.data)

export const readMessages = (roomKey, user) =>
  getClient()
    .then(client => client.put(`rooms/${roomKey}/messages/read`, user))
    .then(res => res.data)

export const receiveMessage = (roomKey, messageKey) =>
  getClient().then(client =>
    client.put(`rooms/${roomKey}/messages/${messageKey}/received`, undefined)
  )
